import { render, staticRenderFns } from "./live-list.vue?vue&type=template&id=42a191e6"
import script from "./live-list.vue?vue&type=script&lang=js"
export * from "./live-list.vue?vue&type=script&lang=js"
import style0 from "./live-list.vue?vue&type=style&index=0&id=42a191e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports